import * as fromActions from '../actions';
import { SoftwaresState } from "../models/store.models";

const initialState: SoftwaresState = {
    softwareToSearch: null
}

export function softwaresReducer(state: SoftwaresState = initialState, action: fromActions.SoftwaresActions): SoftwaresState {
    switch (action.type) {
        case fromActions.SET_SOFTWARE_VALUE:
            return {
                softwareToSearch: action.softwareChosen
            }
        case fromActions.UNSET_SOFTWARE_VALUE:
            return {
                softwareToSearch: null
            }
        case fromActions.UPDATE_SOFTWARE_VALUE:
            return {
                softwareToSearch: action.softwareChosen
            }
        default:
            return state
    }
}
